import {getSession} from "next-auth/react"

import {SYSTEM_BE} from "@/lib/constants"

const Fetch = async (url: string, options: RequestInit = {}) => {

    const fullUrl = `${SYSTEM_BE}${url}`

    const headers = new Headers({
        ...options.headers,
        'Accept': 'application/json'
    })

    const session = await getSession()
    if (session) {
        headers.append('Authorization', `Bearer ${session.accessToken}`)
    }

    const fetchOptions: RequestInit = {
        ...options,
        headers,
    }

    try {
        return await fetch(fullUrl, fetchOptions)
    } catch (error) {
        return Promise.reject(error)
    }
}

export default Fetch;
